<div style="display: block;">
    <canvas baseChart
            [data]="chartData"
            [options]="chartOptions"
            chartType="bar">
    </canvas>
  </div>